var accountSetupFactory = function ($resource, $window) {
    var getContactInformationUrl = "rest/partialauth/contactInformation/accountInfo";

    var updatePersonalContactApi =
        "/participant-web-services/rest/partialauth/profile/updatePersonalContact";

    var registrationUrl = "rest/partialauth/contactInformation/registerUser";

    var updateContactApi = "rest/partialauth/contactInformation/updateContact";

    return {
        getContactInfo: $resource(
            __authenticationUrl__ + getContactInformationUrl,
            {},
            {
                query: {
                    method: "GET"
                }
            }
        ),

        updatePersonalContact: $resource(
            __baseApiUrl__ + updatePersonalContactApi,
            {},
            {
                query: {
                    method: "POST",
                    isArray: false,
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            }
        ),
        registerUser: $resource(
            __authenticationUrl__ + registrationUrl,
            {},
            {
                query: {
                    method: "POST",
                    isArray: false,
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            }
        ),
        updateContact: $resource(
            __authenticationUrl__ + updateContactApi,
            {},
            {
                query: {
                    method: "POST",
                    isArray: false,
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            }
        )
    }; //End of Return
};

accountSetupFactory.$inject = ["$resource", "$window"];
export default accountSetupFactory;
